export const SiteFooter = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#0A0A0A] bg-[#0A0A0A] text-white"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-8 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="font-display font-black text-2xl tracking-tighter">BankDesks.com</div>
          <p className="text-sm text-white/60 mt-3 max-w-xs">
            A public directory of Indian Banks & NBFCs with Nodal, Recovery and Legal contacts.
          </p>
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/60 mb-3">
            Data Source
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="https://rbi.org.in" target="_blank" rel="noreferrer" className="hover:text-[#FF3333] transition-colors">RBI Public Disclosures</a></li>
            <li><a href="https://cms.rbi.org.in" target="_blank" rel="noreferrer" className="hover:text-[#FF3333] transition-colors">RBI CMS (Complaints)</a></li>
            <li><a href="https://rbi.org.in/Scripts/Bs_viewcontent.aspx?Id=3657" target="_blank" rel="noreferrer" className="hover:text-[#FF3333] transition-colors">NBFC Registration List</a></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/60 mb-3">
            Legal
          </div>
          <p className="text-xs text-white/60 leading-relaxed">
            Data compiled from publicly available regulatory disclosures. This directory does
            not guarantee accuracy — always verify on the institution's official website before
            any legal or formal action. No personal data scraped.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
        © 2026 BankDesks.com · Built for the public interest
      </div>
    </footer>
  );
};
